import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-20" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium" }, "1. Wywiad medyczny", -1)
const _hoisted_3 = { class: "mt-20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium mt-12" }, "2. Dane pacjenta", -1)

import { watch } from 'vue';
import { schema } from './schema';
import { initialValues } from './initialValues';
import DateOfIllnessField from '../shared/Fields/DateOfIllnessField.vue';
import DateOfBackToWorkField from '../shared/Fields/DateOfBackToWorkField.vue';
import ImportantInformationField from '../shared/Fields/ImportantInformationField.vue';
import UploadedFileField from '../shared/Fields/UploadedFileField.vue';
import PatientData from '../shared/PatientData.vue';
import ProductForm from '../shared/ProductForm.vue';
import SelectEmployerField from '../shared/Fields/SelectEmployerField.vue';


export default {
  __name: 'Teleporada',
  props: {
    checkoutlink: { type: String, required: true },
    price: {
        type: String,
        required: true,
    },
    id: {
        type: Number,
        required: true,
    },
},
  setup(__props) {

const props = __props;



return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(ProductForm, {
    schema: _unref(schema),
    initialValues: _unref(initialValues),
    id: __props.id,
    checkoutlink: __props.checkoutlink,
    price: __props.price
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(ImportantInformationField),
        _createVNode(UploadedFileField)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(PatientData)
      ])
    ]),
    _: 1
  }, 8, ["schema", "initialValues", "id", "checkoutlink", "price"]))
}
}

}